import { render, staticRenderFns } from "./examine-dialog.vue?vue&type=template&id=39e5d6fe&scoped=true"
import script from "./examine-dialog.vue?vue&type=script&lang=js"
export * from "./examine-dialog.vue?vue&type=script&lang=js"
import style0 from "./examine-dialog.vue?vue&type=style&index=0&id=39e5d6fe&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5d6fe",
  null
  
)

export default component.exports